import { useMutation } from '@tanstack/react-query';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { downloadBlob } from '@common/utils/downloadBlob';
import { apiClient } from '@config/server/apiClient';
import { ordersEndpoints } from '@config/server/apiEndpoints';

/**
 * Export orders request parameters
 */
export interface ExportOrdersParams {
	purchasedVehicleIds?: string[];
}

/**
 * API function to export orders as CSV
 * Downloads the file to the user's machine
 */
export const exportOrders = async (
	servicesProviderId: string,
	params: ExportOrdersParams,
): Promise<void> => {
	const { purchasedVehicleIds } = params;

	// Use apiClient to get blob response
	const blob = await apiClient.postBlob(ordersEndpoints.export(servicesProviderId), {
		purchasedVehicleIds,
	});

	downloadBlob(blob, 'orders.csv');
};

/**
 * Hook for exporting orders as CSV
 */
export const useExportOrders = () => {
	const servicesProviderId = useCurrentServicesProviderId();

	return useMutation({
		mutationFn: async (params: ExportOrdersParams) => {
			if (!servicesProviderId) {
				throw new Error('Cannot export orders without services provider ID');
			}
			return exportOrders(servicesProviderId, params);
		},
	});
};
